import React from "react";

import "../styles/BrandImage.scss";

import { HashLink as Link } from "react-router-hash-link";

function BrandImage() {
  return (
    <Link smooth to="/#start" className="brandImage">
      <span>prom</span>Agency.
    </Link>
  );
}

export default BrandImage;
